export class FirestoreExternalConnectorAuthRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    /**
     * Acquire a lock for the given connector. This can be used to prevent race
     * conditions when updating an auth token.
     *
     * @param connectorName The name of the connector to lock.
     * @param ttl The number of milliseconds to lock the connector for.
     * @returns A function that can be called to release the lock.
     */
    async lock(connectorName, ttl) {
        const lockId = connectorMutexName(connectorName);
        const lockRef = this.db.externalConnectorAuthCollection().doc(lockId);
        await this.db.runTransaction(async (txn) => {
            const lockDoc = await txn.get(lockRef);
            const expireTime = Date.now() + ttl;
            if (lockDoc.exists) {
                if (lockDoc.get("expires") > Date.now()) {
                    throw new Error(`Connector ${connectorName} is already locked`);
                }
                else {
                    txn.update(lockRef, { expires: expireTime });
                }
            }
            else {
                txn.create(lockRef, { expires: expireTime });
            }
        });
        return async () => await void lockRef.delete();
    }
    async get(connectorName) {
        const doc = await this.db.externalConnectorAuthCollection().doc(connectorName).get();
        if (doc.exists) {
            return doc.data();
        }
        else {
            return null;
        }
    }
    async set(connectorName, authData) {
        return await this.db.externalConnectorAuthCollection().doc(connectorName).set(authData);
    }
}
function connectorMutexName(connectorName) {
    return `__${connectorName}_auth_lock`;
}
//# sourceMappingURL=FirestoreExternalConnectorAuthRepository.js.map